import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import Buttons from "../../../library/custom/button/Button";
import AddIcon from "@mui/icons-material/Add";
import { TableLoader } from "../../../library/common/Loader";
import NORow from "../../../library/custom/noRow/noRow";
import {
  API_STATUS,
  NEW_SAFETY_DIVISION_ADMIN,
  ORG_ID,
  PAGE_SIZE,
  ROW_PER_PAGE_SIZE,
  SAFETY_SUPER_ADMIN,
  SEFETY_HBN_CLIENT_PARTNER_PRI,
  SEFETY_HBN_CLIENT_SYSTEM_PRI,
  USER_ID,
} from "../../../constant/constant";
import GridTable from "../../../library/custom/gridTable/GridTable";
import TableRowAction from "../../../library/custom/gridTable/TableRowAction";
import SettingTable from "../../incidents/incidentList/SettingTable";
import SearchIcon from "@mui/icons-material/Search";
import { checkPrivileges, hasAllPrivileges } from "../../../utils/rolesHelper";
import { useNavigate, useLocation } from "react-router-dom";
import DeleteAndDownloadAction from "../../../library/custom/gridTable/deleteAndDownloadAction";
import {
  ADD_INSPECTION_NEW,
  INSPECTION_REPORT,
  REPORTS_ANALYTICS_DASHBOARD,
  REPORTS_ANALYTICS_DASHBOARD_Detail,
  VIEW_INSPECTION_REPORT,
} from "../../../constant/routeContant";
import { getPreviousRoute } from "../../../utils/routeTracker";
import { useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import FilterListIcon from "@mui/icons-material/FilterList";
import InsFilter from "../../admin/shared/InsFilter";
import { getFormatedDate, InactiveClient } from "../../../utils/helper";
import downloadIcon from "../../../assets/downloadIcon.svg";
import BackBtn from "../../../library/custom/backBtn/backBtn";
import {
  deleteInspection,
  getInspectionOpenItemCounts,
} from "../../../redux/actions/incpectionAction";
import { useDispatch } from "react-redux";
import DialogBox from "../../../library/common/DialogBox";
import { PRODUCT_ID } from "../../../constant/storm-water/constant";
import DownloadIcon from "@mui/icons-material/Download";
import { Grid } from "@mui/material";

const InspectionList = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const {
    divisions,
    inspectionList,
    Inspcheck,
    showLoader,
    getInspectionListData,
    quesSet,
    getQuesSetData,
    isEmailSuccess,
    deleteIns,
    deleteInsLoading,
    InspectionOpenItemCount,
    locationData,
    assetOption,
    isAssetLoading,
    searchAsset,
    vehicleCategories,
    equipmentCategories,
    customAssetCategories,
    cleardataInspection,
    shouldRestoreState,
  } = props;

  const inspViewReportList = useSelector((state) => state?.inspViewReportList);
  const [filterObjRestored, setFilterObjRestored] = useState(false);
  const prevPathnameRef = useRef(location.pathname);

  const showEdit =
    checkPrivileges([12]) ||
    hasAllPrivileges(SEFETY_HBN_CLIENT_PARTNER_PRI) ||
    hasAllPrivileges(SEFETY_HBN_CLIENT_SYSTEM_PRI) ||
    hasAllPrivileges(NEW_SAFETY_DIVISION_ADMIN) ||
    hasAllPrivileges(SAFETY_SUPER_ADMIN);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [selectedIds, setSelectedIds] = useState([]);
  const [search, setSearch] = useState("");
  const [isSendEmail, setIsSendEmail] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState("");
  const [isSearchInitialized, setIsSearchInitialized] = useState(false);
  const [isTableLoading, setisTableLoading] = useState(false);

  const [assets, setAssets] = useState(null);
  const autoSearchRef = useRef(null);

  const [selectedReportIds, setSelectedReportIds] = useState([]);
  const [openDownloadConfirm, setOpenDownloadConfirm] = useState(false);
  const [actionType, setActionType] = useState(null);

  const handleDownloadAllClick = () => {
    if (InactiveClient()) return;
    setOpenDownloadConfirm(true);
  };
  const handleCloseDownloadConfirm = () => {
    setOpenDownloadConfirm(false);
  };

  let contentMessage;
  if (InspectionOpenItemCount === "" || InspectionOpenItemCount === 0) {
    contentMessage = "Are you sure you want to delete this report?";
  } else if (InspectionOpenItemCount !== 0) {
    contentMessage = `This report has ${InspectionOpenItemCount} open item(s). Are you sure you want to delete this report?`;
  }
  const searchTimer = useRef(null);
  // Filters State
  const [filters, setFilters] = useState({
    fromDate: "",
    toDate: "",
    divisionId: "",
    assetTypeId: "",
    assetCategoryId: "",
    statusId: "",
    inspectionType: "",
  });

  const ASSET_TYPE_MAP = {
    1: "Project",
    2: "Equipment",
    3: "Vehicle",
    4: "Custom Asset",
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    window.close();
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const buildPayload = useCallback(
    (pageNo, size, searchText = "", overrideFilters = filters) => ({
      compnayId: "",
      divisionId:
        overrideFilters.divisionId === "AllDivisions"
          ? 0
          : overrideFilters.divisionId || "",
      searchInspection: searchText,
      startDate:
        overrideFilters.fromDate === null || overrideFilters.fromDate === ""
          ? ""
          : getFormatedDate(overrideFilters.fromDate),
      endDate:
        overrideFilters.toDate === null || overrideFilters.toDate === ""
          ? ""
          : getFormatedDate(overrideFilters.toDate),
      status: overrideFilters.statusId || "",
      inspectionTypes: overrideFilters.inspectionType || "",
      pageSize: size,
      page: pageNo,
      assetTypeId: overrideFilters.assetTypeId || "",
      assetId: overrideFilters?.assetId || "",
      assetCategoryId:
        overrideFilters.assetCategoryId === "AllCategory"
          ? 0
          : overrideFilters.assetCategoryId || 0,
      organisationId: ORG_ID(),
      userId: overrideFilters?.userId || (Inspcheck ? 0 : USER_ID()),
      isSendMail: false,
      isReportView: overrideFilters.isReportView || false,
    }),
    [filters, Inspcheck, search],
  );

  const handlePageChange = useCallback(
    (newPage) => {
      const currentPage = newPage + 1;
      setPage(currentPage);
      getInspectionListData(buildPayload(currentPage, pageSize, search));
      setIsSendEmail(false);
    },
    [buildPayload, getInspectionListData, pageSize, search],
  );

  const handlePageSizeChange = useCallback(
    (newSize) => {
      setPageSize(newSize);
      setPage(1);
      getInspectionListData(buildPayload(1, newSize, search));
      setIsSendEmail(false);
    },

    [buildPayload, getInspectionListData, search],
  );

  const buildNavState = (extra = {}) => {
    return {
      page,
      pageSize,
      search,
      filters,
      userId: locationData?.userId || "",
      assetCategoryId: locationData?.assetCatId || 0,
      isReportView: filters.isReportView || false,
      routeName: locationData?.routeName || "",
      drillDetailPage: locationData?.drillDetail?.page,
      apiData: locationData?.drillDetail?.apiData,
      tab: locationData?.drillDetail?.tab,
      drillDetail: locationData?.drillDetail,
      reportDetails: props.drillDetail?.reportDetails,
      backpage: "backpage",
      ...extra,
    };
  };

  const handleRowClick = useCallback(
    (row) => {
      if (!row?.id) return;

      navigate(INSPECTION_REPORT, {
        state: buildNavState({
          reportId: row.id,
        }),
      });
    },
    [navigate, page, pageSize, search, filters],
  );

  const handleSearchChange = (value) => {
    setSearch(value);

    if (searchTimer.current) {
      clearTimeout(searchTimer.current);
    }

    searchTimer.current = setTimeout(() => {
      setPage(1);
      setisTableLoading(true);
      setTimeout(() => {
        setisTableLoading(false);
      }, 1);
      getInspectionListData(buildPayload(1, pageSize, value));
    }, 500);

    setIsSendEmail(false);
  };

  const handleViewOnClick = (reportId) => {
    sessionStorage.setItem("inspectionListPreserveState", "true");
    navigate(INSPECTION_REPORT, {
      state: buildNavState({
        reportId,
      }),
    });
  };

  const handleEditOnClick = (row) => {
    if (InactiveClient()) return;
    sessionStorage.setItem("inspectionListPreserveState", "true");
    navigate(ADD_INSPECTION_NEW, {
      state: buildNavState({
        row,
        editMode: true,
      }),
    });
  };

  const columns = useMemo(
    () => [
      {
        field: "reportId",
        headerName: "Report ID",
        flex: 1,
      },
      {
        field: "dateOfEntry",
        headerName: "Date of Entry",
        flex: 1.5,
      },
      {
        field: "inspectionType",
        headerName: "Inspection Type",
        flex: 2,
      },
      {
        field: "assetType",
        headerName: "Asset Type",
        flex: 1.5,
        renderCell: ({ row }) => ASSET_TYPE_MAP[row?.assetType] || "N/A",
      },
      {
        field: "asset",
        headerName: "Asset Name",
        flex: 1.5,
      },
      {
        field: "inspectionBy",
        headerName: "Inspected By",
        flex: 1.5,
      },
      {
        field: "status",
        headerName: "Status",
        flex: 1,
      },
      {
        field: "action",
        width: 75,
        sortable: false,
        disableClickEventBubbling: true,

        renderHeader: () => (
          <SettingTable
            noOfRecords={inspectionList?.recordsCount ?? 0}
            numberOfItemsPerPage={pageSize}
            incidentLists={inspectionList?.inspectionReports ?? []}
            fileNameXL="inspections"
          />
        ),

        renderCell: (params) => (
          <div
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <TableRowAction
              rows={params}
              actionData={[
                "View Details",
                "Edit Incident",
                "Download Report",
                "Delete Incident",
              ]}
              usingComp="Inspection"
              view={checkPrivileges([12, 120, 121, 122, 4, 6, 5])}
              deleted={checkPrivileges([12, 120, 121, 4])}
              edit={
                (params?.row?.statusId === 1 &&
                  checkPrivileges([12, 120, 121, 4, 5])) ||
                (params?.row?.statusId === 5 && showEdit)
              }
              editLabel={"Edit Inspection"}
              viewLabel={"View Inspection"}
              deleteLabel={"Delete Inspection"}
              viewOnClick={() => handleViewOnClick(params?.row?.reportId)}
              editOnClick={() => handleEditOnClick(params?.row)}
              deleteOnClick={() => deleteIncpection(params?.row)}
            />
          </div>
        ),
      },
    ],
    [inspectionList, pageSize],
  );

  // Filter Change Handlers
  const fromDateHandler = (val) => {
    setFilters((prev) => ({ ...prev, fromDate: val }));
  };

  const toDateHandler = (val) => {
    setFilters((prev) => ({ ...prev, toDate: val }));
  };

  const divisionOnChanges = (e) => {
    setFilters((prev) => ({ ...prev, divisionId: e.target.value }));
  };

  const assetTypeOnChanges = (e) => {
    const value = e?.target?.value;
    setFilters((prev) => ({
      ...prev,
      assetTypeId: value,
      assetCategoryId: "",
      inspectionType: "",
    }));
    setAssets(null);

    let flags = [6];
    if (value === 2) {
      flags.push(10);
    } else if (value === 3) {
      flags.push(11);
    } else if (value === 4) {
      flags.push(13);
    }
    const getDropdownDataKeyValueData = {
      orgId: ORG_ID(),
      flags: flags,
      Clientid: ORG_ID(),
      productId: PRODUCT_ID(),
    };
    props.getDropDownData(getDropdownDataKeyValueData);
  };

  const categoryOnChanges = (e) => {
    setFilters((prev) => ({ ...prev, assetCategoryId: e.target.value }));
    setAssets(null);
  };

  const statusOnChanges = (e) => {
    setFilters((prev) => ({ ...prev, statusId: e.target.value }));
  };

  const inspectionTypeOnChanges = (e) => {
    setFilters((prev) => ({ ...prev, inspectionType: e.target.value }));
  };

  const handleAssetOnChange = (value) => {
    setAssets(value);
    setFilters((prev) => ({ ...prev, assetId: value?.key || "" }));
  };

  const handleApplyFilter = () => {
    setPage(1);
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);

    getInspectionListData(buildPayload(1, pageSize, search));
    setAnchorEl(null);
    setIsSendEmail(false);
  };

  const sendEmail = () => {
    const payload = buildPayload(page || 1, pageSize);

    getInspectionListData({
      ...payload,
      isSendMail: true,
    });
    setIsSendEmail(true);
    setActionType("downloadData");
  };

  const handleResetFilter = () => {
    const resetData = {
      fromDate: "",
      toDate: "",
      divisionId: "",
      assetTypeId: "",
      assetCategoryId: "",
      statusId: "",
      inspectionType: "",
    };

    setFilters(resetData);
    setSearch("");
    setPage(1);
    setPageSize(PAGE_SIZE);
    setIsSendEmail(false);
    setAssets(null);
    getInspectionListData(buildPayload(1, PAGE_SIZE, "", resetData));

    setAnchorEl(null);
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
  };

  const deleteIncpection = (rows) => {
    if (InactiveClient()) return;
    setOpenModal(true);
    setSelectedRow(rows);
    const data = {
      inspectionId: rows?.reportId,
      organisationId: parseInt(ORG_ID()),
    };

    dispatch(getInspectionOpenItemCounts(data));
  };

  const deleteItem = React.useCallback(
    (item, action) => {
      if (action === "single") {
        dispatch(deleteInspection(item?.reportId));
      } else {
      }
    },
    [dispatch],
  );

  const deletehandle = () => {
    setOpenModal(false);
    const data = {
      InspectionId: selectedRow?.reportId,
      organisationId: parseInt(ORG_ID()),
    };

    dispatch(deleteInspection(data));
  };

  useEffect(() => {
    const data = {
      SubClassId: "",
      organisationId: ORG_ID(),
      assetTypeId: filters.assetTypeId || "",
      isActive: false,
    };
    getQuesSetData({ data });
  }, [filters.assetTypeId]);

  useEffect(() => {
    if (deleteIns?.status === API_STATUS.SUCCESS) {
      if (inspViewReportList?.filterObj) {
        getInspectionListData(inspViewReportList.filterObj);
      } else {
        setFilters({
          fromDate: "",
          toDate: "",
          divisionId: "",
          assetTypeId: "",
          assetCategoryId: "",
          statusId: "",
          inspectionType: "",
        });
        setSearch("");
        setPage(1);
        setPageSize(PAGE_SIZE);
        setIsSendEmail(false);
        getInspectionListData(
          buildPayload(1, PAGE_SIZE, "", {
            fromDate: "",
            toDate: "",
            divisionId: "",
            assetTypeId: "",
            assetCategoryId: "",
            statusId: "",
            inspectionType: "",
          }),
        );
      }
    }
  }, [deleteIns]);

  const dataBack = {
    title: "Back",
    route:
      locationData?.routeName === REPORTS_ANALYTICS_DASHBOARD
        ? REPORTS_ANALYTICS_DASHBOARD
        : locationData?.routeName === REPORTS_ANALYTICS_DASHBOARD_Detail
          ? REPORTS_ANALYTICS_DASHBOARD_Detail
          : -1,
    state: {
      page: locationData?.drillDetail?.page,
      apiData: locationData?.drillDetail?.apiData,
      tab: locationData?.drillDetail?.tab,
      drillDetail: locationData?.drillDetail,
      reportDetails: locationData?.drillDetail?.reportDetails,
      backpage: "backpage",
    },
  };

  // Monitor route changes and handle state reset when returning from Add page
  useEffect(() => {
    const currentPathname = location.pathname;
    const previousPathname = prevPathnameRef.current;

    // Detect navigation back to inspection list from another route
    if (previousPathname !== currentPathname && isSearchInitialized) {
      const allowedRoutePrefixes = [
        VIEW_INSPECTION_REPORT,
        INSPECTION_REPORT,
        ADD_INSPECTION_NEW,
      ];
      const previousRoute = getPreviousRoute();
      const shouldPreserve =
        previousRoute &&
        allowedRoutePrefixes.some((prefix) =>
          previousRoute.startsWith(prefix),
        ) &&
        sessionStorage.getItem("inspectionListPreserveState") === "true";

      sessionStorage.removeItem("inspectionListPreserveState");

      // If coming from Add page or other non-preserve route, reset state
      if (
        previousRoute &&
        allowedRoutePrefixes.some((prefix) =>
          previousRoute.startsWith(prefix),
        ) &&
        !shouldPreserve
      ) {
        setFilters({
          fromDate: "",
          toDate: "",
          divisionId: "",
          assetTypeId: "",
          assetCategoryId: "",
          statusId: "",
          inspectionType: "",
        });
        setSearch("");
        setPage(1);
        setPageSize(PAGE_SIZE);
        getInspectionListData(
          buildPayload(1, PAGE_SIZE, "", {
            fromDate: "",
            toDate: "",
            divisionId: "",
            assetTypeId: "",
            assetCategoryId: "",
            statusId: "",
            inspectionType: "",
          }),
        );
      }
    }

    prevPathnameRef.current = currentPathname;
  }, [location.pathname]);

  useEffect(() => {
    if (locationData && !isSearchInitialized) {
      // Check if coming from Create New Report (drillDetail is null/undefined)
      // or if preserve flag is not set (meaning it's a reset scenario)
      const shouldResetFromDrillDetail =
        !locationData?.drillDetail &&
        sessionStorage.getItem("inspectionListPreserveState") !== "true";

      sessionStorage.removeItem("inspectionListPreserveState");

      if (shouldResetFromDrillDetail) {
        // Reset state when coming from Create New Report with no drillDetail
        setFilters({
          fromDate: "",
          toDate: "",
          divisionId: "",
          assetTypeId: "",
          assetCategoryId: "",
          statusId: "",
          inspectionType: "",
        });
        setSearch("");
        setPage(1);
        setPageSize(PAGE_SIZE);
        setAssets(null);
        setIsSendEmail(false);
        setIsSearchInitialized(true);
        setFilterObjRestored(true);
        getInspectionListData(buildPayload(1, PAGE_SIZE, ""));
      } else {
        // Preserve state when coming from dashboard with drillDetail or Edit/View
        const dashboardFilters = {
          fromDate: locationData?.fromDate || "",
          toDate: locationData?.toDate || "",
          divisionId:
            locationData?.divisionId === "AllDivisions"
              ? 0
              : locationData?.divisionId || "",
          assetTypeId: locationData?.assetType || "",
          statusId: locationData?.status || "",
          userId: locationData?.userId || "",
          inspectionType:
            locationData?.inspectionType === "AllInspectionTypes"
              ? ""
              : locationData?.inspectionType,
          isReportView: locationData?.isReportView,
          assetCategoryId: locationData?.assetCatId,
          assetId: locationData?.assetId,
          assetValue: locationData?.assetValue,
        };
        const initSearch = locationData?.search || "";
        const restoredPage = locationData?.pageNo || 1;
        const restoredPageSize = locationData?.pageSize || PAGE_SIZE;

        setFilters(dashboardFilters);
        setSearch(initSearch);
        setPage(restoredPage);
        setPageSize(restoredPageSize);
        setIsSendEmail(false);
        setIsSearchInitialized(true);
        setFilterObjRestored(true);
        setAssets({
          key: locationData?.assetId,
          value: locationData?.assetValue,
        });
        getInspectionListData(
          buildPayload(
            restoredPage,
            restoredPageSize,
            initSearch,
            dashboardFilters,
          ),
        );
      }

      const value = locationData?.assetType;
      let flags = [6];
      if (value === 2) {
        flags.push(10);
      } else if (value === 3) {
        flags.push(11);
      } else if (value === 4) {
        flags.push(13);
      }

      const getDropdownDataKeyValueData = {
        orgId: ORG_ID(),
        flags: flags,
        Clientid: ORG_ID(),
        productId: PRODUCT_ID(),
      };
      props.getDropDownData(getDropdownDataKeyValueData);
      return;
    }

    if (!locationData && !isSearchInitialized) {
      const allowedRoutePrefixes = [
        VIEW_INSPECTION_REPORT,
        INSPECTION_REPORT,
        ADD_INSPECTION_NEW,
      ];
      const previousRoute = getPreviousRoute();
      const isFromPreserveRoute =
        previousRoute &&
        allowedRoutePrefixes.some((prefix) =>
          previousRoute.startsWith(prefix),
        ) &&
        sessionStorage.getItem("inspectionListPreserveState") === "true";
      sessionStorage.removeItem("inspectionListPreserveState");

      setIsSearchInitialized(true);

      if (isFromPreserveRoute && inspViewReportList?.filterObj) {
        const f = inspViewReportList.filterObj;
        const restoredFilters = {
          fromDate: f.startDate || "",
          toDate: f.endDate || "",
          divisionId: f.divisionId || "",
          assetTypeId: f.assetTypeId || "",
          assetCategoryId: f.assetCategoryId || "",
          statusId: f.status || "",
          inspectionType: f.inspectionTypes || "",
          assetId: f.assetId || "",
          userId: f.userId || "",
          isReportView: f.isReportView || false,
        };
        const restoredPage = f.page || 1;
        const restoredPageSize = f.pageSize || PAGE_SIZE;
        const restoredSearch = f.searchInspection || "";
        setFilters(restoredFilters);
        setSearch(restoredSearch);
        setPage(restoredPage);
        setPageSize(restoredPageSize);
        setFilterObjRestored(true);
        getInspectionListData(
          buildPayload(
            restoredPage,
            restoredPageSize,
            restoredSearch,
            restoredFilters,
          ),
        );
      } else {
        setFilters({
          fromDate: "",
          toDate: "",
          divisionId: "",
          assetTypeId: "",
          assetCategoryId: "",
          statusId: "",
          inspectionType: "",
        });
        setSearch("");
        setPage(1);
        setPageSize(PAGE_SIZE);
        setFilterObjRestored(true);
        getInspectionListData(buildPayload(1, PAGE_SIZE, ""));
      }
    }
  }, [locationData, isSearchInitialized]);

  /**
   * ! Download Report Button Function
   * @returns Download Report Button function call
   */
  const handleDownloadReport = () => {
    if (InactiveClient()) return;
    if (!selectedReportIds.length) {
      toast.error("Please select at least one report.");
      return;
    }
    const payload = buildPayload(page || 1, pageSize);

    getInspectionListData({
      ...payload,
      isSendMail: true,
      isAllInspection: false,
      inspectionIds: selectedReportIds,
    });

    setIsSendEmail(true);
    setActionType("downloadSelected");
  };
  /**
   * ! Down Load All Email data Function
   * @returns Fownload All Email Button after popup open
   */
  const handleConfirmDownloadAllEmailData = () => {
    if (InactiveClient()) return;
    const payload = buildPayload(page || 1, pageSize);
    getInspectionListData({
      ...payload,
      isSendMail: true,
      isAllInspection: true,
      inspectionIds: [],
    });

    setIsSendEmail(true);
    setOpenDownloadConfirm(false);
    setActionType("emailAll");
  };

  useEffect(() => {
    if (isEmailSuccess && isSendEmail && actionType) {
      switch (actionType) {
        case "downloadData":
          toast.success("Inspection has been sent to registered email ID");
          break;

        case "downloadSelected":
          toast.success(
            "Selected Inspection Reports have been sent to registered email ID",
          );
          break;

        case "emailAll":
          toast.success(
            "All inspection reports have been emailed successfully",
          );
          break;

        default:
          toast.success("some thing went wrong ");
      }

      setIsSendEmail(false);
      setActionType(null);
      cleardataInspection();
    }
  }, [isEmailSuccess, isSendEmail, actionType]);

  return (
    <>
      <ToastContainer />
      <section className="grid_main_sec">
        {openModal && (
          <DialogBox
            open={openModal}
            rows={[]}
            header={"Confirm Deletion"}
            deletehandle={deletehandle}
            handleCloseModal={() => setOpenModal(false)}
            content={contentMessage}
            view
          />
        )}
        {openDownloadConfirm && (
          <DialogBox
            open={openDownloadConfirm}
            header="Confirm Download"
            content="Are you sure you want to download all data?"
            deletehandle={handleConfirmDownloadAllEmailData}
            handleCloseModal={handleCloseDownloadConfirm}
            view={false}
            deleteIcon={false}
          />
        )}

        <div className="grid_main_header two_grid">
          <div
            className="grid_heading_style"
            data-testid="inspection-list-heading"
          >
            Inspection Reports
          </div>
          <div className="header-buttons">
            <Buttons
              primary={true}
              label={"Email All Reports"}
              onClick={handleDownloadAllClick}
              startIcon={<DownloadIcon className="downloadIcon" />}
            />
            {checkPrivileges([12, 120, 121, 4, 5]) && (
              <Buttons
                primary={true}
                label={"Create New Report"}
                onClick={() => {
                  if (InactiveClient()) return;
                  sessionStorage.removeItem("inspectionListPreserveState");
                  setFilters({
                    fromDate: "",
                    toDate: "",
                    divisionId: "",
                    assetTypeId: "",
                    assetCategoryId: "",
                    statusId: "",
                    inspectionType: "",
                  });
                  setSearch("");
                  setPage(1);
                  setPageSize(PAGE_SIZE);
                  setAssets(null);
                  setIsSearchInitialized(false);
                  navigate(ADD_INSPECTION_NEW, { state: null });
                }}
                startIcon={<AddIcon />}
              />
            )}
          </div>
        </div>

        <div className="grid_main_body">
          <Grid container className="fixedDesign div-filter-container gapNone">
            <Grid item sm={6} md={6} xs={12}>
              <div className="filter_of_caselist">
                <div className="searchcaseid">
                  <label htmlFor="search">
                    <span>
                      <SearchIcon />
                    </span>

                    <div>
                      <input
                        id="search"
                        placeholder="Search"
                        type="text"
                        value={search}
                        autoComplete="off"
                        onChange={(e) => handleSearchChange(e.target.value)}
                      />
                    </div>
                  </label>
                </div>
                <div className="filter_btn insFilter">
                  <button
                    aria-describedby={id}
                    variant="contained"
                    type="button"
                    name="btn"
                    onClick={(e) => handleClick(e)}
                  >
                    <FilterListIcon id="icn" /> Filters
                  </button>

                  <div className="grid_main_body">
                    <div className="div-filter-container">
                      <InsFilter
                        open={open}
                        anchorEl={anchorEl}
                        handleClose={handleClose}
                        handleApply={handleApplyFilter}
                        handleClear={handleResetFilter}
                        resetBtn={true}
                        filterDate={true}
                        division={true}
                        assetType={true}
                        status={true}
                        InspectionType={true}
                        fromDate={filters.fromDate}
                        toDate={filters.toDate}
                        fromDateHandler={fromDateHandler}
                        toDateHandler={toDateHandler}
                        divisionList={divisions}
                        divisionId={filters.divisionId}
                        divisionOnChanges={divisionOnChanges}
                        assetTypeId={filters.assetTypeId}
                        assetTypeOnChanges={assetTypeOnChanges}
                        categoryId={filters.assetCategoryId}
                        categoryOnChanges={categoryOnChanges}
                        vehicleCategories={vehicleCategories}
                        equipmentCategories={equipmentCategories}
                        customAssetCategories={customAssetCategories}
                        statusId={filters.statusId}
                        statusOnChanges={statusOnChanges}
                        inspectionTypeId={filters.inspectionType}
                        inspectionTypeOnChanges={inspectionTypeOnChanges}
                        quesSet={quesSet}
                        assets={assets}
                        searchAsset={searchAsset}
                        isAssetLoading={isAssetLoading}
                        assetOption={assetOption}
                        handleAssetOnChange={handleAssetOnChange}
                        autoSearch={autoSearchRef}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Grid>
            <Grid item sm={6} md={6} xs={12}>
              <Grid container spacing={1}>
                <Grid item md={7} xs={12} className="emailRight">
                  {selectedReportIds?.length > 0 && (
                    <>
                      <div
                        className="div-verify-email-right"
                        onClick={handleDownloadReport}
                      >
                        <span>
                          <img
                            src={downloadIcon}
                            className="DownLoadLogo"
                            alt="DownLoad Logo"
                          />
                        </span>
                        Download Reports
                      </div>
                    </>
                  )}
                </Grid>
                <Grid item md={5} xs={12}>
                  <div className="div-download-email-right" onClick={sendEmail}>
                    <span>
                      <img
                        src={downloadIcon}
                        className="DownLoadLogo"
                        alt="DownLoad Logo"
                      />
                    </span>
                    Download Data
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </section>

      <div className="desc_box row_uniq">
        <div className="table_style_ui">
          {isTableLoading ? (
            ""
          ) : (
            <GridTable
              getRowId={(r) => r.reportId}
              rows={showLoader ? [] : (inspectionList?.inspectionReports ?? [])}
              rowCount={inspectionList?.recordsCount ?? 0}
              columns={columns}
              checkboxSelection={true}
              pagination
              page={page - 1}
              pageSize={pageSize}
              rowsPerPageOptions={ROW_PER_PAGE_SIZE}
              loading={showLoader || deleteInsLoading}
              disableSelectionOnClick
              backIconButtonProps={{ disabled: false }}
              onPageChange={handlePageChange}
              onPageSizeChange={handlePageSizeChange}
              // onClick={handleRowClick}
              onRowClick={(params) => handleRowClick(params.row)}
              // onSelectionModelChange={setSelectedIds}
              onSelectionModelChange={(ids) => setSelectedReportIds(ids)}
              components={{
                LoadingOverlay: TableLoader,
                NoRowsOverlay: NORow,
              }}
            />
          )}
        </div>

        {selectedIds.length > 0 && (
          <DeleteAndDownloadAction
            reportIdOfChekbox={selectedIds}
            incidentLists={inspectionList?.inspectionReports ?? []}
            filename="Inspection-Reports"
            deleteOnClick={() => deleteItem(null, "multiple")}
          />
        )}

        <BackBtn dataBack={dataBack} />
      </div>
    </>
  );
};

export default InspectionList;
